module.exports = __webpack_public_path__ + "static/media/features-build-image.3f562112.jpg";